var _defs, _path, _path2, _path3, _path4, _path5, _text, _text2, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiseacademylogo06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 50 650 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea0054;}.cls-2{fill:#f7941d;}.cls-3{fill:#029ac9;}.cls-4{fill:#006838;}.cls-5{font-size:155.08px;font-family:Raleway-SemiBold, Raleway;font-weight:600;}.cls-6{font-size:37.81px;}.cls-12,.cls-14,.cls-6{font-family:Raleway-Bold, Raleway;font-weight:700;}.cls-7{letter-spacing:-0.01em;}.cls-8{letter-spacing:-0.04em;}.cls-9{letter-spacing:-0.07em;}.cls-10{letter-spacing:-0.03em;}.cls-11{letter-spacing:0em;}.cls-12{font-size:33.96px;}.cls-13{letter-spacing:-0.03em;}.cls-14{font-size:40.16px;}.cls-15{letter-spacing:-0.02em;}.cls-16{letter-spacing:-0.03em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.32,227.5H141.83V192.57H166.6c8.18,0,15.28,7.94,15.28,17.4C181.88,219.2,176.07,227.5,167.32,227.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.44,159V280.63H221.11V159Zm83.85,108.24L164.11,237H141.83v30.2H131.16V183.08h36c14.8,0,25.46,13.62,25.46,26.89,0,11.72-7,22.26-17.64,25l20.37,32.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.68,159V280.63h121.7V159Zm67.47,108.24H288.49v-84h10.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.58,289.09V410.77h121.7V289.09Zm60.64,105.83A53.62,53.62,0,0,1,126,383.06l5.09-9c5.09,5.33,16.59,11.23,29.38,11.23,12,0,19-4.37,19-12.79,0-9.47-8.65-12.31-24.29-16.09-17.07-4.16-25.94-8.77-25.94-22.16,0-16.12,12.79-24.87,30.2-24.87A42.77,42.77,0,0,1,187,319l-5,8.65c-3.92-4.4-12.81-8.77-22.88-8.77-13,0-18.94,5.21-18.94,13.75,0,9,7,11.35,22.14,14.8,17.53,3.92,28.43,8.89,28.43,24C190.77,387.7,177.5,394.92,160.22,394.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.85,289.09V410.77H353.53V289.09Zm88.51,105H263.27V310h56v9.5H273.93v27.23h39.45v8.89H273.93v29h46.43Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(385.03 268.29)"
  }, "RISE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(393.97 324.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 25.18,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 51.65,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.39,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 98.92,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.17,
    y: 0,
    xmlSpace: "preserve"
  }, " IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 168.87,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 191.97,
    y: 0
  }, "TITUTE "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(392.43 407.77)"
  }, "ENTREPRENEUSHIP")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(392.96 370.31)"
  }, "O", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 29.72,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.73,
    y: 0,
    xmlSpace: "preserve"
  }, " SCIENCE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 230.49,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 238.84,
    y: 0
  }, "AND "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiseacademylogo06);
export default __webpack_public_path__ + "static/media/rise academy logo-06.8713031fff1e18245073a672f3d543fe.svg";
export { ForwardRef as ReactComponent };